module.exports = __webpack_public_path__ + "img/3.5617fe71.png";